import { Spinner } from "@/components/ui/spinner";
import { useSession } from "@/utils/session.ctx";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useFocusEffect, useLocalSearchParams, useRouter } from "expo-router";
import { useCallback } from "react";
import { Buffer } from "buffer";

function getTokenExpiration(token: string): number | undefined {
  try {
    const payloadBase64 = token.split(".")[1];
    if (!payloadBase64) return undefined;

    // Добавим padding для корректной base64-декодировки
    const paddedPayload = payloadBase64.padEnd(
      payloadBase64.length + ((4 - (payloadBase64.length % 4)) % 4),
      "="
    );

    const decodedPayload = JSON.parse(
      Buffer.from(paddedPayload, "base64").toString("utf-8")
    );

    const exp = decodedPayload.exp;
    if (typeof exp !== "number") return undefined;

    return exp * 1000;
  } catch (e) {
    console.warn("Failed to decode token:", e);
    return undefined;
  }
}

export default function AuthWithAccessToken() {
  const { token } = useLocalSearchParams<{ token?: string }>();
  const router = useRouter();
  const { isAuthenticated, isInitialized } = useSession();

  useFocusEffect(
    useCallback(() => {
      if (!token) {
        router.replace("/");
        return;
      }

      if (!isInitialized) {
        return;
      }

      if (!isAuthenticated) {
        router.replace("/");
        return;
      }

      AsyncStorage.multiSet([
        ["impersonation", token],
        ["impersonation-exp", getTokenExpiration(token)?.toString() ?? ""],
      ]).then(() => {
        router.replace("/");
      });
    }, [isAuthenticated, isInitialized, token])
  );

  return <Spinner size="large" />;
}
